<template>
  <div class="register_box">
    <a-form
      ref="registerForm"
      name="registerForm"
      :model="formRegisterData"
      :rules="formRegRulesData"
    >
      <div v-show="stepIndex == 0">
        <a-form-item label="" name="employeeName">
          <a-input
            v-model:value="formRegisterData.employeeName"
            size="large"
            :maxlength="20"
            placeholder="请输入您的姓名"
          />
        </a-form-item>
        <a-form-item label="" name="account">
          <a-input
            v-model:value="formRegisterData.account"
            size="large"
            :maxlength="18"
            placeholder="请输入您的身份证号"
          />
        </a-form-item>
        <a-form-item label="" name="qqNum">
          <a-input
            v-model:value="formRegisterData.qqNum"
            size="large"
            :maxlength="18"
            placeholder="请输入您的QQ号"
          />
        </a-form-item>

        <!-- 文件上传 -->
        <a-form-item label="" name="studentImage">
          <div class="upload_box">
            <div class="upload_img">
              <UploadAvatar v-model:fileUrl="formRegisterData.studentImage" />
            </div>
            <div class="upload_tip_box">
              <div class="t1">图片要求：</div>
              <div class="t1">小于5MB</div>
              <!-- <div class="t1">114像素(宽) * 156像素(高)</div> -->
            </div>
          </div>
        </a-form-item>
      </div>
      <div v-show="stepIndex == 1">
        <a-form-item label="" name="phoneNumber">
          <a-input
            v-model:value="formRegisterData.phoneNumber"
            size="large"
            :maxlength="11"
            placeholder="请输入手机号"
          />
        </a-form-item>
        <!-- <a-form-item label="" name="captcha">
          <div class="dis_ajc">
            <a-input-search
              v-model:value="formRegisterData.captcha"
              placeholder="请输入验证码"
              size="large"
              :maxlength="8"
              @search="onSend"
            >
              <template #enterButton>
                <a-button
                  style="width: 136px"
                  type="primary"
                  size="large"
                  :disabled="codeData.state"
                  :loading="codeData.loading"
                >
                  {{ codeData.txt }}
                </a-button>
              </template>
            </a-input-search>
          </div>
        </a-form-item> -->
        <a-form-item label="" name="password">
          <a-input-password
            v-model:value="formRegisterData.password"
            size="large"
            :maxlength="20"
            placeholder="请输入登录密码"
          />
        </a-form-item>
        <a-form-item label="" name="password2">
          <a-input-password
            v-model:value="formRegisterData.password2"
            size="large"
            :maxlength="20"
            placeholder="请再次输入登录密码"
          />
        </a-form-item>
      </div>
    </a-form>
    <div class="form_btn">
      <template v-if="stepIndex == 0">
        <a-button
          type="primary"
          block
          size="large"
          @click="registerSubmitChange"
        >
          下一步
        </a-button>
      </template>
      <template v-else>
        <a-button class="btn" size="large" @click="stepIndex = 0">
          上一步
        </a-button>
        <a-button
          class="btn"
          type="primary"
          size="large"
          :loading="registerLoading"
          @click="registerSubmitChange"
        >
          {{ stepIndex == 0 ? "下一步" : "注册" }}
        </a-button>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, defineEmits, onMounted, defineExpose } from "vue";
import { message } from "ant-design-vue";

import { sendSmsCaptcha } from "@/api/validation.js";
import { userStudentRegister } from "@/api/user.js";
import { getRsa } from "@/utils/function.js";
import { idCardValidate } from "@/utils/validate.js";

import UploadAvatar from "@/views/my_page/components/upload_avatar.vue";

const emit = defineEmits(["registerSuccess"]);

const stepIndex = ref(0); // 注册步骤
// 注册表单信息
const registerForm = ref(null);
const formRegisterData = ref({});
const formRegRulesData = ref({
  employeeName: [
    {
      required: true,
      validator: (rule, value, callback) => {
        if (value == null || value.trim() === "") {
          return Promise.reject("请输入您的姓名");
        }
        const chineseReg = /^[\u4e00-\u9fa5]+$/;
        if (chineseReg.test(value.trim())) {
          return Promise.resolve();
        } else {
          return Promise.reject("请输入正确的姓名");
        }
      },
      trigger: "blur",
    },
  ],
  account: [
    {
      required: true,
      validator: (rule, value) => {
        return idCardValidate(rule, value);
      },
      trigger: "blur",
    },
  ],
  qqNum: [{ required: true, message: "请输入您的QQ号" }],
  studentImage: [
    { required: true, message: "请上传照片", trigger: ["change"] },
  ],
  phoneNumber: [
    // { required: true, message: '请输入手机号' }
    {
      validator: (rule, value, callback) => {
        let length = value?.trim().length || 0;
        if (length == 11) {
          const phoneReg = /^1[3,4,5,6,7,8,9][0-9]{9}$/; // 手机号正则
          if (phoneReg.test(value.trim())) {
            return Promise.resolve();
          } else {
            return Promise.reject("请输入正确的手机号");
          }
        } else {
          let str = length == 0 ? "请输入手机号" : "请输入正确的手机号";
          return Promise.reject(str);
        }
      },
      trigger: ["change", "blur"],
    },
  ],
  captcha: [{ required: true, message: "请输入验证码" }],
  password: [
    {
      validator: (rule, value, callback) => {
        let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)([a-zA-Z0-9]){8,16}$/;
        // 含大小写字符和数字。长度8-16位
        if (!value) {
          callback("请输入登录密码");
        } else if (regex.test(value)) {
          callback();
        } else {
          callback("密码长度8-16位，包含大小写英文和数字");
        }
      },
      trigger: ["change", "blur"],
    },
  ],
  password2: [
    {
      validator: (rule, value, callback) => {
        if (formRegisterData.value.password == value) {
          callback();
        } else if (value == "") {
          callback("请再次输入登录密码");
        } else {
          callback("两次密码不一致");
        }
      },
      trigger: ["change", "blur"],
    },
  ],
});
const registerLoading = ref(false);
//根据身份证提取性别
const extractBirthAndGender = (idCard) => {
  if (!idCard || idCard.length !== 18) {
    throw new Error("身份证号无效");
  }

  // 提取性别
  const genderCode = parseInt(idCard.charAt(16), 10);
  const gender = genderCode % 2 === 1 ? 1 : 2;

  return {
    gender: gender,
  };
}; // 下一步、注册
function registerSubmitChange() {
  if (!stepIndex.value) {
    // 第一步的数据
    registerForm.value
      .validateFields(["employeeName", "account", "qqNum", "studentImage"])
      .then(() => {
        // console.log('验证通过');
        stepIndex.value = 1;
      })
      .catch((err) => {
        console.log("err==", err);
      });
    return;
  }

  registerLoading.value = true;
  registerForm.value
    .validate()
    .then(async () => {
      let { account, password, phoneNumber } = formRegisterData.value;
      let parmas = {
        ...formRegisterData.value,
        captcha:'0000',
        account: await getRsa(account),
        password: await getRsa(password),
        phoneNumber: await getRsa(phoneNumber),
        sex: extractBirthAndGender(account).gender,
      };
      delete parmas.password2;
      userStudentRegister(parmas)
        .then(async (res) => {
          // console.log("res===", res);
          message.success({ content: "注册成功", duration: 3 });
          setTimeout(() => {
            registerLoading.value = false;
          }, 1500);

          let { vx } = res;
          localStorage.setItem("access_token2", vx);
          emit("registerSuccess", res); // 注册完成触发事件
        })
        .catch((err) => {
          registerLoading.value = false;
          console.log("err==", err);
        });
    })
    .catch((err) => {
      registerLoading.value = false;
      console.log("err==", err);
    });
}

function resettingChange() {
  stepIndexChange();
  // fileList.value = [];
  registerForm.value.resetFields();
}
function stepIndexChange() {
  stepIndex.value = 0;
}

const picVerifyRef = ref(null);
const codeData = reactive({
  state: false,
  loading: false,
  txt: "发送验证码", // 60s后重新获取
});
const onSend = () => {
  let phone = formRegisterData.value.phoneNumber;
  registerForm.value
    .validateFields(["phoneNumber"])
    .then(async () => {
      codeData.loading = true;
      try {
        let res = await sendSmsCaptcha({ phoneNumber: phone });
        codeData.loading = false;
        txtChange();
      } catch (error) {
        codeData.loading = false;
      }
    })
    .catch((err) => {
      console.log("err==", err.errorFields[0].errors[0]);
      message.warn(err.errorFields[0]?.errors[0] || "");
    });
};
// 图形验证码校验成功
// const verifySuccess = () => {
//   message.success("短信已发送");
//   state.picVerifyShow = false;
//   txtChange();
// };

// 发送按钮 变化
function txtChange(i = 60) {
  codeData.state = true;
  codeData.txt = i + "s后重新获取";
  let timeObj = setInterval(() => {
    i--;
    if (i <= 0) {
      codeData.txt = "发送验证码";
      codeData.state = false;
      clearInterval(timeObj);
    } else {
      codeData.txt = i + "s后重新获取";
    }
  }, 1000);
}

defineExpose({
  resettingChange,
  stepIndexChange,
});
</script>

<style lang="scss" scoped>
@import "@/style/var.scss";
.register_box {
  width: 100%;
}

.upload_box {
  display: flex;
  .upload_btn {
    width: 100px;
    height: 100px;
    color: #999999;
    border: 1px dashed #c9c9c9;
    border-radius: 4px;
    flex-direction: column;
    cursor: pointer;
    overflow: hidden;
    &:hover {
      color: $primary-color;
      border-color: $primary-color;
    }
    .user_avatar {
      width: 100%;
      height: auto;
    }
  }
  .upload_tip_box {
    flex: 1;
    padding: 20px;
    line-height: 1.3;
    color: #999999;
  }
}

.form_btn {
  display: flex;
  justify-content: space-between;
  .btn {
    width: 45%;
  }
}
</style>
